import { z } from 'zod';

// ============================================
// Current Employee (self) Schemas
// ============================================

export const currentEmployeeSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  canViewCost: z.boolean().optional(),
  // metaData is a JSON column on BusinessEmployees. Declare only the keys
  // the FE actually reads — add new ones here as the FE grows to need them.
  metaData: z
    .object({
      templateEmailNotification: z.boolean().optional(),
      webhookFailureEmailNotification: z.boolean().optional(),
    })
    .optional(),
});

export type CurrentEmployee = z.infer<typeof currentEmployeeSchema>;

// ============================================
// Self-update request body (PUT /business-employees/me)
// ============================================

// Fields the logged-in employee may change on their own record. Merge
// semantics — anything not present is untouched. .strict() rejects any
// non-self-editable key (e.g. quickReplies must not be writable here).
export const updateSelfSchema = z
  .object({
    metaData: z
      .object({
        templateEmailNotification: z.boolean().optional(),
        webhookFailureEmailNotification: z.boolean().optional(),
      })
      .strict()
      .optional(),
  })
  .strict();

export type UpdateSelfType = z.infer<typeof updateSelfSchema>;
